import {api} from "./axios";

export const emailLogsApi = {

    
    getSentEmails: (params?: { page?: number; limit?: number }) =>
    api.get("/email/logs", { params }),

  // Get pitches with email logs
  getPitchesWithEmails: (params?: { page?: number; limit?: number; sortBy?: string; sortOrder?: string }) =>
    api.get("/email", { params }),

  // Get email logs for a specific pitch
  getEmailLogsByPitch: (pitchId: number, params?: { page?: number; limit?: number }) =>
    api.get(`/email/logs/${pitchId}`, { params }),

  // Resend a failed email
  resendEmail: (emailLogId: string) =>
    api.post(`/email/resend/${emailLogId}`),

  // Get email content by log ID
  getEmailContent: (logId: string) =>
    api.get(`/email/log/${logId}`),

  // checkBounceStatus: (pitchId: number) =>
  //   api.post(`email/check-bounce/${pitchId}`),

}